import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { PrimaryColors } from '@picsart/design-system/foundation/primaryColors';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';

const useStyles = createUseStyles(
  {
    container: {
      position: 'relative',
    },
    button: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s4,
      backgroundColor: BackgroundColors.tint1,
      border: 'none',
      borderRadius: CornerRadius.r8,
      padding: [Spacings.s4, Spacings.s8],
      fontSize: FontSizes.s12,
      fontWeight: FontWeights.semibold,
      color: TextColors.base,
      cursor: 'pointer',
      '&:focus': {
        outline: 'none',
        boxShadow: `0 0 0 2px ${PrimaryColors.base.default}`,
      },
    },
    icon: {
      width: 12,
      height: 12,
      transition: 'transform 0.2s ease',
    },
    iconOpen: {
      transform: 'rotate(180deg)',
    },
    menu: {
      position: 'absolute',
      top: '100%',
      right: 0,
      marginTop: Spacings.s4,
      backgroundColor: BackgroundColors.base,
      border: [1, 'solid', BackgroundColors.tint3],
      borderRadius: CornerRadius.r8,
      padding: Spacings.s4,
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
      zIndex: StackingContext.PopoverLayer,
      minWidth: 60,
    },
    menuItem: {
      display: 'block',
      width: '100%',
      padding: [Spacings.s8, Spacings.s12],
      border: 'none',
      borderRadius: CornerRadius.r4,
      backgroundColor: 'transparent',
      color: TextColors.tint1,
      fontSize: FontSizes.s12,
      fontWeight: FontWeights.medium,
      textAlign: 'center',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: BackgroundColors.tint2,
      },
    },
    menuItemActive: {
      backgroundColor: BackgroundColors.tint2,
      color: TextColors.base,
    },
  },
  { name: 'size-selector' }
);

export default useStyles;
